// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/tools/v1/stainless.proto (package gitpod.tools.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumOptions, FieldOptions, MessageOptions, MethodOptions, ServiceOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/tools/v1/stainless.proto.
 */
export const file_gitpod_tools_v1_stainless: GenFile = /*@__PURE__*/
  fileDesc("Ch9naXRwb2QvdG9vbHMvdjEvc3RhaW5sZXNzLnByb3RvEg9naXRwb2QudG9vbHMudjEiHgoOU3RhaW5sZXNzRmllbGQSDAoEc2tpcBgBIAEoCCJICg5TdGFpbmxlc3NNb2RlbBIQCghyZXNvdXJjZRgBIAEoCRIMCgRuYW1lGAIgASgJEhYKDmZvcmNlX25vX21vZGVsGAMgASgIIiQKEFN0YWlubGVzc1NlcnZpY2USEAoIcmVzb3VyY2UYASABKAkiNgoPU3RhaW5sZXNzTWV0aG9kEhAKCHJlc291cmNlGAEgASgJEhEKCW9wZXJhdGlvbhgCIAEoCTpxChFzdGFpbmxlc3Nfc2VydmljZRIfLmdvb2dsZS5wcm90b2J1Zi5TZXJ2aWNlT3B0aW9ucxi15QMgASgLMiEuZ2l0cG9kLnRvb2xzLnYxLlN0YWlubGVzc1NlcnZpY2VSEHN0YWlubGVzc1NlcnZpY2U6bQoQc3RhaW5sZXNzX21ldGhvZBIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGLblAyABKAsyIC5naXRwb2QudG9vbHMudjEuU3RhaW5sZXNzTWV0aG9kUg9zdGFpbmxlc3NNZXRob2Q6awoPc3RhaW5sZXNzX21vZGVsEh8uZ29vZ2xlLnByb3RvYnVmLk1lc3NhZ2VPcHRpb25zGLflAyABKAsyHy5naXRwb2QudG9vbHMudjEuU3RhaW5sZXNzTW9kZWxSDnN0YWlubGVzc01vZGVsOmYKDnN0YWlubGVzc19lbnVtEhwuZ29vZ2xlLnByb3RvYnVmLkVudW1PcHRpb25zGLjlAyABKAsyHy5naXRwb2QudG9vbHMudjEuU3RhaW5sZXNzTW9kZWxSDXN0YWlubGVzc0VudW06aQoPc3RhaW5sZXNzX2ZpZWxkEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxi55QMgASgLMh8uZ2l0cG9kLnRvb2xzLnYxLlN0YWlubGVzc0ZpZWxkUg5zdGFpbmxlc3NGaWVsZEJDWkFnaXRodWIuY29tL2dpdHBvZC1pby9naXRwb2QtbmV4dC9hcGkvZ28vdG9vbHMvc3RhaW5sZXNzO3N0YWlubGVzc2IGcHJvdG8z", [file_google_protobuf_descriptor]);

/**
 * @generated from message gitpod.tools.v1.StainlessField
 */
export type StainlessField = Message<"gitpod.tools.v1.StainlessField"> & {
  /**
   * skip excludes this field from the generated SDKs.
   *
   * @generated from field: bool skip = 1;
   */
  skip: boolean;
};

/**
 * Describes the message gitpod.tools.v1.StainlessField.
 * Use `create(StainlessFieldSchema)` to create a new message.
 */
export const StainlessFieldSchema: GenMessage<StainlessField> = /*@__PURE__*/
  messageDesc(file_gitpod_tools_v1_stainless, 0);

/**
 * @generated from message gitpod.tools.v1.StainlessModel
 */
export type StainlessModel = Message<"gitpod.tools.v1.StainlessModel"> & {
  /**
   * @generated from field: string resource = 1;
   */
  resource: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool force_no_model = 3;
   */
  forceNoModel: boolean;
};

/**
 * Describes the message gitpod.tools.v1.StainlessModel.
 * Use `create(StainlessModelSchema)` to create a new message.
 */
export const StainlessModelSchema: GenMessage<StainlessModel> = /*@__PURE__*/
  messageDesc(file_gitpod_tools_v1_stainless, 1);

/**
 * @generated from message gitpod.tools.v1.StainlessService
 */
export type StainlessService = Message<"gitpod.tools.v1.StainlessService"> & {
  /**
   * @generated from field: string resource = 1;
   */
  resource: string;
};

/**
 * Describes the message gitpod.tools.v1.StainlessService.
 * Use `create(StainlessServiceSchema)` to create a new message.
 */
export const StainlessServiceSchema: GenMessage<StainlessService> = /*@__PURE__*/
  messageDesc(file_gitpod_tools_v1_stainless, 2);

/**
 * @generated from message gitpod.tools.v1.StainlessMethod
 */
export type StainlessMethod = Message<"gitpod.tools.v1.StainlessMethod"> & {
  /**
   * @generated from field: string resource = 1;
   */
  resource: string;

  /**
   * @generated from field: string operation = 2;
   */
  operation: string;
};

/**
 * Describes the message gitpod.tools.v1.StainlessMethod.
 * Use `create(StainlessMethodSchema)` to create a new message.
 */
export const StainlessMethodSchema: GenMessage<StainlessMethod> = /*@__PURE__*/
  messageDesc(file_gitpod_tools_v1_stainless, 3);

/**
 * @generated from extension: gitpod.tools.v1.StainlessService stainless_service = 62133;
 */
export const stainless_service: GenExtension<ServiceOptions, StainlessService> = /*@__PURE__*/
  extDesc(file_gitpod_tools_v1_stainless, 0);

/**
 * @generated from extension: gitpod.tools.v1.StainlessMethod stainless_method = 62134;
 */
export const stainless_method: GenExtension<MethodOptions, StainlessMethod> = /*@__PURE__*/
  extDesc(file_gitpod_tools_v1_stainless, 1);

/**
 * @generated from extension: gitpod.tools.v1.StainlessModel stainless_model = 62135;
 */
export const stainless_model: GenExtension<MessageOptions, StainlessModel> = /*@__PURE__*/
  extDesc(file_gitpod_tools_v1_stainless, 2);

/**
 * @generated from extension: gitpod.tools.v1.StainlessModel stainless_enum = 62136;
 */
export const stainless_enum: GenExtension<EnumOptions, StainlessModel> = /*@__PURE__*/
  extDesc(file_gitpod_tools_v1_stainless, 3);

/**
 * @generated from extension: gitpod.tools.v1.StainlessField stainless_field = 62137;
 */
export const stainless_field: GenExtension<FieldOptions, StainlessField> = /*@__PURE__*/
  extDesc(file_gitpod_tools_v1_stainless, 4);

